const colors = {
  basic01: '#0E1013',
  basic02: '#2E3134',
  basic03: '#3C4043',
  basic04: '#5F6368',
  basic05: '#9AA0A6',
  basic06: '#BDC1C6',
  basic07: '#DADCE0',
  basic08: '#E8EAED',
  basic09: '#F1F3F4',
  basic10: '#F8F9FA',
  basic11: '#FFFFFF',
  basic12: '#343434',
  secondary01: '#A40000',
  secondary02: '#BC2200', // error color
  secondary03: '#D82C0D',
  secondary04: '#007E33', // success color
  secondary05: '#A16B00', // warning color
  secondary06: '#7B61FF',
  secondary07: '#FFE9E8',
  secondary08: '#FDEFEF',
  secondary09: '#E0FFED',
  secondary10: '#FFFAEA',
  secondary11: '#F2F2F2',
  secondary12: '#444444',
  primary: '#8575E5',
  designStudioPink: '#EC79AD',
};

export default colors;
